<template>
  <div>
    <h3 class="tw:text-xl tw:font-bold tw:mb-5 tw:mt-6">{{ $t(question[id]) }}</h3>
    <textarea
      data-testid="feedback-field-textarea"
      class="tw:outline-none tw:w-full tw:text-xl tw:border tw:border-gray-500 tw:rounded-md tw:px-4 tw:py-3.5 tw:max-h-[150px]"
      :placeholder="$t('business_studio_plus_share_feedback')"
      style="height: 58px"
      @input="updateOtherExplanation"
    />
  </div>
</template>
<script setup>
const emit = defineEmits(['updateOtherExplanation'])
const updateOtherExplanation = event => emit('updateOtherExplanation', event.target.value)

defineProps({
  id: String,
})
const question = {
  offseason: 'sub_cancel_season_feedback',
  change_of_ownership: 'sub_cancel_feedback_ownership',
  using_another_partner: 'sub_cancel_feedback_competitor',
  no_roi: 'sub_cancel_feedback_roi',
  too_expensive: 'sub_cancel_feedback_price',
  found_cheaper: 'sub_cancel_feedback_cost_effective',
  budget_constraints: 'sub_cancel_feedback_budget',
  dont_understand_features: 'sub_cancel_feedback_support',
  dont_understand_insights: 'sub_cancel_feedback_support',
  no_support: 'sub_cancel_feedback_support',
  doesnt_meet_needs: 'sub_cancel_feedback_product_fit',
  too_complex: 'sub_cancel_feedback_simplicity',
  property_closed: 'sub_cancel_feedback_usefulness',
  other: 'sub_cancel_feedback_experience',
}
</script>
